import { GCCalendarAPI } from '@business/api/gc_calendar';
import { Blocs } from '@business/blocs';
import { GCCalendarEventObjectType, GCCalendarEventResponse } from '@business/entities/gc_calendar';
import { BaseBloc } from '@core/utils/bloc';
import { resolve } from '@core/utils/ioc';
import { LoadingState } from '@core/utils/repository/loading_state';
import { BehaviorSubject, forkJoin } from 'rxjs';
import { tap } from 'rxjs/operators';

export class GCCalendarEventsListBloc extends BaseBloc {
  private readonly calendarBloc = resolve(Blocs.gcCalendarEvent);
  private readonly userBloc = resolve(Blocs.user);

  constructor(private objectType = GCCalendarEventObjectType.Organization, private objectId?: string) {
    super();
  }

  //   events$ = new BehaviorSubject<GCCalendarEventResponse[] | null>(null);
  events$ = this.calendarBloc.events$;

  loading = new LoadingState();
  users$ = this.userBloc.staff$;

  onInit() {
    return forkJoin([
      this.onReload(),
      this.userBloc.fetchUsers(),

      //   GCCalendarAPI.events({
      //     objectId: this.objectId,
      //     objectType: this.objectType,
      //   }).pipe(tap(events => this.events$.next(events))),
    ]).pipe(this.loading.run());
  }

  deleteEvent = this.calendarBloc.deleteEvent;

  onReload() {
    return this.calendarBloc
      .allEvents({
        objectId: this.objectId,
        objectType: this.objectType,
      })
      .subscribe();
  }
}
